/**
 * Presets for the Edge-TTS backed text-to-speech pipeline. The server
 * passes the `voiceId` straight to `edge-tts` (i.e. the short-name
 * Microsoft Azure voice id) so these strings MUST match values accepted
 * by `edge_tts.Communicate(..., voice=...)`.
 *
 * Keep the catalog small and focused on Chinese voices — they're what
 * the WeChat console is likely to hit. Adding a new card is a one-liner:
 * pick a voice id from `edge-tts --list-voices` and include it here.
 */
export type TtsVoiceModel = {
    id: string
    name: string
    desc: string
    /** Single-character glyph the UI renders inside the round avatar. */
    avatar: string
    /** Default emoji-style background colour for the avatar circle. */
    avatarBg?: string
}

export type TtsSettings = {
    enabled: boolean
    selectedVoiceId: string
}

/**
 * The empty string is the sentinel for "use the server default voice",
 * which in turn falls back to the first entry in VOICE_MODELS.
 */
export const DEFAULT_TTS_VOICE_ID = ''

export const TTS_VOICE_MODELS: TtsVoiceModel[] = [
    {
        id: 'zh-CN-XiaoxiaoNeural',
        name: '晓晓',
        desc: '温柔女声',
        avatar: '晓',
        avatarBg: '#ffdfbf',
    },
    {
        id: 'zh-CN-YunyangNeural',
        name: '云扬',
        desc: '沉稳男声',
        avatar: '扬',
        avatarBg: '#c0aede',
    },
    {
        id: 'zh-CN-XiaoyiNeural',
        name: '晓伊',
        desc: '活泼女声',
        avatar: '伊',
        avatarBg: '#b6e3f4',
    },
    {
        id: 'zh-CN-YunxiNeural',
        name: '云希',
        desc: '自然男声',
        avatar: '希',
        avatarBg: '#d1f0a5',
    },
]
